import React from 'react';
import MaskedInput from 'react-text-mask';

import { FieldProps } from 'formik';

const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const phoneDigits = (phone: string | null | undefined): string => (phone ? phone.replace(/\D/g, '') : '');

const lastTen = (digits: string): string => {
	if (!digits) return '';
	if (digits.length <= 10) return digits;
	return digits.slice(-10);
};

const formatPhone = (input: string | null | undefined): string => {
	const digits = phoneDigits(input);
	const lastTenDigits = lastTen(digits);

	if (lastTenDigits.length < 4) return lastTenDigits;
	if (lastTenDigits.length < 7) {
		return `(${lastTenDigits.slice(0, 3)}) ${lastTenDigits.slice(3)}`;
	}

	return `(${lastTenDigits.slice(0, 3)}) ${lastTenDigits.slice(3, 6)}-${lastTenDigits.slice(6, 10)}`;
};

interface Props {
	placeholder?: string;
	fieldProps: FieldProps;
	className?: string;
	withReplace?: boolean;
	prefixIcon?: string;
	autocomplete?: null | 'off' | string;
	touchedOnFocus?: boolean;
	onChange?: (val: string) => void;
}

export const CustomPhoneControl: React.FC<Props> = ({
	placeholder = '',
	fieldProps: { field, form },
	className = 'form-control',
	prefixIcon = '',
	autocomplete = 'new-password',
	touchedOnFocus = false,
	onChange,
}) => {
	const value = React.useMemo(() => formatPhone(field.value), [field.value]);

	return (
		<>
			{prefixIcon && (
				<div className="custom-input__prefix-icon">
					<img src={prefixIcon} alt="img" />
				</div>
			)}

			<MaskedInput
				type="tel"
				mask={phoneMask}
				className={className}
				placeholder={placeholder}
				guide
				id={field.name}
				autoComplete={autocomplete}
				value={value}
				onInput={(e) => {
					const inputDigits = phoneDigits(e.target.value);

					if (inputDigits.length > 10) return;

					const formatted = formatPhone(inputDigits);

					form.setFieldValue(field.name, formatted);
					onChange && onChange(formatted);
				}}
				onPaste={(e) => {
					e.preventDefault();

					const pasted = phoneDigits(e.clipboardData.getData('Text'));
					const lastTenDigits = lastTen(pasted);

					form.setFieldValue(field.name, formatPhone(lastTenDigits));
				}}
				onBlur={() => form.setFieldTouched(field.name, true)}
				onFocus={() => {
					touchedOnFocus && form.setFieldTouched(field.name, true);
				}}
			/>
		</>
	);
};
